import Button from 'components/Button/Button';
import { CardBrands } from 'types';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import CardBrandSelect from './CardBrandSelect';
import MccField from './MccField';
import React from 'react';
import classNames from 'classnames';
import style from './AdditionalMccCard.module.scss';

interface IAdditionalMccCard {
	fieldId: string;
	useCustomerMcc: boolean;
	selectedAdditionalMccCardBrand: CardBrands | null;
	reservedMccCardBrands: (CardBrands | null)[];
	isShowAdditionalMccCards: boolean;
	changeMccCardBrand: (id: string, value: CardBrands) => void;
	changeMccCardMcc: (id: string, value: Nullable<number>) => void;
	deleteMccCard: (id: string) => void;
	setShowAdditionalMccCards: (value: boolean) => void;
}

const AdditionalMccCard: React.FC<IAdditionalMccCard> = ({
	fieldId,
	selectedAdditionalMccCardBrand,
	changeMccCardBrand,
	changeMccCardMcc,
	deleteMccCard,
	setShowAdditionalMccCards,
	reservedMccCardBrands,
	isShowAdditionalMccCards,
	useCustomerMcc,
}) => {
	const containerClasses = classNames(style.container, { [style.visible]: isShowAdditionalMccCards });

	const handleDeleteField = () => {
		deleteMccCard(fieldId);
	};

	return (
		<div className={containerClasses}>
			<CardBrandSelect
				fieldId={fieldId}
				selectedAdditionalMccCardBrand={selectedAdditionalMccCardBrand}
				reservedMccCardBrands={reservedMccCardBrands}
				changeMccCardBrand={changeMccCardBrand}
				setShowAdditionalMccCards={setShowAdditionalMccCards}
				useCustomerMcc={useCustomerMcc}
			/>
			<MccField
				fieldId={fieldId}
				changeMccCardMcc={changeMccCardMcc}
				setShowAdditionalMccCards={setShowAdditionalMccCards}
				useCustomerMcc={useCustomerMcc}
			/>
			<Button
				className={style.button}
				theme="clear"
				disabled={useCustomerMcc}
				icon={
					<svg className={style.closeIcon} onClick={handleDeleteField}>
						<use xlinkHref={`${breadcrumbs}#crossMark`} />
					</svg>
				}
			/>
		</div>
	);
};

export default React.memo(AdditionalMccCard);
